/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import DateFnsUtils from "@date-io/date-fns";

import { API, graphqlOperation } from "aws-amplify";
import { getAccount } from "../../../graphql/account/account-queries";
import { areaByActiveBySortKey } from "../../../graphql/reloadyard/custom-queries";

import {
  Box,
  Grid,
  InputAdornment,
  makeStyles,
  TextField as MuiTextField,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import {
  ArrayField,
  ArrayInput,
  AutocompleteInput,
  Button,
  Create,
  Datagrid,
  FileInput,
  FormDataConsumer,
  FormTab,
  FunctionField,
  minLength,
  minValue,
  number,
  NumberInput,
  RadioButtonGroupInput,
  required,
  SelectInput,
  SimpleFormIterator,
  TabbedForm,
  TextInput,
  Toolbar,
  TopToolbar,
  useNotify,
} from "react-admin";
import { useForm } from "react-final-form";
import {
  isAuthorized,
  logError,
  setupLocationMaps,
} from "../../../utils/appUtils";
import {
  ACCEPTED_FILES,
  AclType,
  CARLOT_PO_NO_CHARS,
  CarrierType,
  CarrierTypes,
  FilePaths,
  InboundStepsChoices,
  InventoryField,
  InventoryStatus,
  AccountType,
  LotTypes,
  MAX_FILES,
  MAX_PHOTO_NUM_INBOUND,
  RA_REQUIRED,
  ResourceType,
  TrueOrFalse,
  Workflow,
} from "../../../utils/constants";
import { handleFileChange } from "../../../utils/fileUtils";
import {
  fetchCarrierEquipmentTypes,
  getCommodityUnits,
  getRailEquipmentTypes,
  getTruckEquipmentTypes,
  getUnitName,
  getWeightUOM,
  isBulkCommodity,
  isInventoryFieldVisible,
  unitOptionRenderer,
} from "../../../utils/loadTypeUtils";
import { getBackPath } from "../../../utils/utils";

import {
  AttachFileIcon,
  CopyDownIcon,
  CreatedAtIcon,
  RemoveIcon,
  SealIcon,
} from "../../../components/common/iconography";
import { AccountDropDown } from "../../../components/common/AccountDropDown";
import { BackButton } from "../../../components/common/BackButton";
import { CarrierNameInput } from "../../../components/common/CarrierNameInput";
import { CopyToClipboardButton } from "../../../components/common/CopyToClipboardButton";
import {
  CustomFields,
  CustomFieldsButton,
  CustomFieldsTallySheet,
} from "../../../components/common/CustomFields";
import { BetaBadge, NewBadge } from "../../../components/common/FeatureBadges";
import { Checklist } from "../../../components/common/Checklist";
import { FileField } from "../../../components/common/FileField";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { NotesTab } from "../../../components/common/NotesTab";
import PhotoInput from "../../../components/common/PhotoInput";
import { SmartTipIcon } from "../../../components/common/SmartTipIcon";
import { EventsCalendar } from "../../../components/common/EventsCalendar";
import { Scheduler } from "../../../components/common/scheduler/Scheduler";
import {
  resolveScheduledDateTime,
  getDateTimeFromUtc,
} from "../../../utils/dateUtils";

import {
  fetchInboundBillingRules,
  filterApplicableManualRules,
  getManualRuleChoices,
} from "../accounts/chargeRules/ChargeRuleUtils";
import { ChargeEvent } from "../accounts/chargeRules/chargeRuleConstants";
import { showWeight } from "../inventory/InventoryUitls";
import { SealNumbersCreateDialog } from "./SealNumbersDialog";
import { ValidateCreateButton } from "./ValidateCreateButton";
import { AdviceCreateForm } from "./advice/AdviceCreateForm";
import { ValidateCreateAdviceButton } from "./advice/ValidateCreateAdviceButton";
import { InboundCreateHelp } from "./InboundHelp";
import {
  AddCatalogUploadButtons,
  applyManualRuleDefaultQuantity,
  autogenLotNumber,
  calcNetWeight,
  calcTotalQuantity,
  getAutoCharges,
  getInfoBubble,
  getManualChargeAmount,
  handleAreaChange,
  handleCommodityChange,
  handleContainerDropChange,
  handleContainerNumberChange,
  handleInventoriesQty,
  handleInventoriesWeight,
  handleLotTypeChange,
  handleSITChange,
  handleUnitChange,
  isContainerDropEnabled,
  isSITDisabled,
  validatePoNumberUnicity,
  validateRailCarNumberUnicity,
} from "./InboundUtils";
import {
  getEffectiveSkipInvoice,
  isBrokeredAccount,
  isInternalAccount,
  resolveBillToAccount,
} from "../accounts/AccountUtils";

const useStyles = makeStyles((theme) => ({
  arrayInput: {
    marginTop: theme.spacing(0),
  },
  arrayInputHeader: {
    display: "flex",
    marginTop: theme.spacing(1),
    marginBottom: -theme.spacing(1),
    justifyContent: "space-between",
  },
  fileInput: {
    marginTop: -theme.spacing(0),
  },
}));

const validateRequired = required();
const validatePoNo = [required(), minLength(CARLOT_PO_NO_CHARS)];
export const validateContainerNumber = [required(), minLength(1)];
const validateQuantity = [required(), number(), minValue(0)];
const validatePieces = [number(), minValue(1)];
const validateRequiredFiles = (value) =>
  Array.isArray(value) && value.length > 0 ? undefined : RA_REQUIRED;

// Keeps the parent's lifted `isSit` state in sync with the live form value so
// that tab visibility (the Checklist tab) reacts to toggling the SIT radio on
// or off, and to the auto-disable in handleAreaChange — not just the flag that
// was passed in via navigation state at mount.
const SitStateSync = ({ sit, setIsSit }) => {
  useEffect(() => {
    setIsSit(Boolean(sit));
  }, [sit, setIsSit]);
  return null;
};

const ShipmentSetupTab = ({
  account,
  setAccount,
  yardCommodity,
  setYardCommodity,
  photos,
  setPhotos,
  entryPoint,
  setIsSit,
  ...props
}) => {
  const form = useForm();
  const notify = useNotify();
  const classes = useStyles();
  const [lotNumber, setLotNumber] = useState("");
  const [areas, setAreas] = useState(
    window.appUser.reloadYard?.areas.items.filter(
      (itm) => itm.active === "true",
    ),
  );
  const [area, setArea] = useState();
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [duplicatePoNumber, setDuplicatePoNumber] = useState(null);
  const [railEquipmentChoices, setRailEquipmentChoices] = useState(
    getRailEquipmentTypes,
  );
  const [truckEquipmentChoices, setTruckEquipmentChoices] = useState(
    getTruckEquipmentTypes(),
  );
  const [carrierEquipmentChoices, setCarrierEquipmentChoices] = useState([]);
  const [allAccounts, setAllAccounts] = useState([]);
  // The account dropdown stays live while its lookups run — its loading prop
  // only draws a spinner — so picking a second account before the first one
  // resolves leaves two handlers racing, and the slower one wins. Each handler
  // records the selection it is working on here and stops at every resume
  // point once a newer selection has taken over, otherwise the form keeps the
  // new accountId alongside the old account's billing defaults.
  const accountRequestRef = useRef(null);
  const yardCommodities = window.appUser.reloadYard.activeYardCommodities.items;

  useEffect(() => {
    getSetupData();
  }, []);

  // When SIT is pre-set from the create entry point, the SIT radio's onChange
  // never fires, so apply the same defaults it would (carrier type RAIL, track
  // area, lot type) on mount. Without this the disabled Carrier Type field is
  // left empty instead of defaulting to RAIL.
  useEffect(() => {
    if (form.getState().values.sit) {
      handleSITChange(true, form, account, setArea);
      // Default the Load Type to "Other" for SIT shipments.
      const otherCommodity = yardCommodities?.find(
        (yc) => yc.commodity?.name === "Other",
      );
      if (otherCommodity) {
        form.change("reloadYardCommodityId", otherCommodity.id);
        handleCommodityChange(
          otherCommodity.id,
          form,
          setYardCommodity,
          area,
          setAreas,
        );
      }
    }
  }, []);

  useEffect(() => {
    if (areas.length === 1) {
      form.change("areaId", areas[0].id);
      handleAreaChange(areas[0].id, areas, setArea, form, notify);
    }
  }, [areas]);

  const getSetupData = async () => {
    try {
      setLoading(true);

      const areaPromise = API.graphql(
        graphqlOperation(areaByActiveBySortKey, {
          reloadYardId: window.appUser?.reloadYardId,
          activeSortKey: { beginsWith: { active: "true" } },
          limit: 1000,
        }),
      );

      const carrierEquipmentPromise = fetchCarrierEquipmentTypes();

      // Use Promise.all to wait for both promises to resolve
      const [areaResp, carrierEquipmentResp] = await Promise.all([
        areaPromise,
        carrierEquipmentPromise,
      ]);

      const areas = areaResp.data.areaByActiveBySortKey.items;
      const carrierEquipment = carrierEquipmentResp;

      window.appUser.reloadYard.areas.items = areas;
      setupLocationMaps(window.appUser.reloadYard);
      setAreas(areas);
      setRailEquipmentChoices(carrierEquipment.railEquipmentTypes);
      setTruckEquipmentChoices(carrierEquipment.truckEquipmentTypes);
    } catch (error) {
      logError("inboundShipment:InboundCreate:getSetupData", error, notify);
    } finally {
      setLoading(false);
    }
  };

  const handleAccountChange = async (value, formData) => {
    const accountId = value?.id ?? null;
    // Claimed before the accountId check so that clearing the field also
    // invalidates whatever lookup is still in flight.
    accountRequestRef.current = accountId;
    const isCurrentSelection = () => accountRequestRef.current === accountId;
    setDuplicatePoNumber(null);

    if (accountId) {
      try {
        setLoading(true);
        let resp = await API.graphql(
          graphqlOperation(getAccount, { id: accountId }),
        );
        if (!isCurrentSelection()) return;
        let acct = resp.data.getAccount;

        if (acct.checklists) {
          acct.checklists.items = acct.checklists.items.filter(
            (itm) => itm.active,
          );
        }
        form.change("account", acct);
        // BROKERED: auto-populate billToAccountId from the account's defaultBillToAccountId.
        // INTERNAL: leave null — user picks the billing account from the picker.
        // CUSTOMER: leave null — billToAccountId falls back to accountId at save time.
        const isBrokered = acct.accountType === AccountType.BROKERED;
        form.change(
          "billToAccountId",
          isBrokered ? (acct.defaultBillToAccountId ?? null) : null,
        );
        const broker = await resolveBillToAccount(acct, allAccounts);
        if (!isCurrentSelection()) return;
        // Origin follows the account: the broker's name for BROKERED, otherwise
        // cleared so the previous account's broker cannot linger in the field.
        form.change("shipFrom", broker ? broker.businessName : null);
        form.change("inventories.items", null); // products are account-linked
        form.change("inventories", null);
        form.change("instructions", acct.inboundInstructions);
        form.change("checklistId", null);
        form.change("checklist", null);
        // BROKERED: shipment bills to the broker, so skipInvoice follows the
        // broker; the operating account's own flag would hide billing forever.
        form.change("skipInvoice", getEffectiveSkipInvoice(acct, broker));
        form.change("manualCharges.items", []);

        if (formData.stockImport) {
          form.change("skipInvoice", true);
        }

        if (!formData.sit) {
          setArea(null);
          form.change("areaId", null);
          form.change("zoneId", null);
          if (formData.containerDrop) {
            handleContainerDropChange(true, form);
          } else {
            form.change("secondaryReview", acct.secondaryReview ? true : false);

            const lotType = acct.lotType ? acct.lotType : "";
            const lotNumberOverride = acct.lotNumberOverride ? true : false;
            form.change("lotType", lotType);
            form.change("lotNumberOverride", lotNumberOverride);
            if (lotNumberOverride !== true) {
              form.change(
                "lotNumber",
                autogenLotNumber(lotType, formData, acct),
              );
            } else {
              form.change("lotNumber", "");
            }
          }
        } else {
          // SIT keeps its track area, but the track zones must be re-filtered
          // against the newly selected account. The mount-time SIT setup runs
          // before an account is chosen, so account-scoped zones would
          // otherwise stay unfiltered (filterZones treats a missing accountId
          // as "match all"). Re-run SIT setup now that we have the account.
          handleSITChange(true, form, acct, setArea);
        }

        setAccount(acct);
        const duplicateInbound = await validatePoNumberUnicity(
          { ...formData, accountId },
          notify,
        );
        if (!isCurrentSelection()) return;
        setDuplicatePoNumber(duplicateInbound);
      } catch (error) {
        logError(
          "inboundShipment:InboundCreate:handleAccountChange",
          error,
          // A superseded lookup still logs, but notifying would raise an error
          // about an account the user has already moved off.
          isCurrentSelection() ? notify : false,
        );
      } finally {
        // The current handler owns the spinner; a superseded one must leave it.
        if (isCurrentSelection()) setLoading(false);
      }
    }
  };
  const handleAccountChangeAdvice = async (value, formData) => {
    const accountId = value?.id ?? null;
    accountRequestRef.current = accountId;
    const isCurrentSelection = () => accountRequestRef.current === accountId;

    if (accountId) {
      try {
        setLoading(true);
        let resp = await API.graphql(
          graphqlOperation(getAccount, { id: accountId }),
        );
        if (!isCurrentSelection()) return;
        let acct = resp?.data?.getAccount;
        if (!acct) {
          throw new Error(`Account ${accountId} not found`);
        }
        form.change("account", acct);
        // BROKERED: auto-populate billToAccountId from the account's defaultBillToAccountId.
        // INTERNAL: leave null — user picks the billing account from the picker.
        // CUSTOMER: leave null — billToAccountId falls back to accountId at save time.
        const isBrokered = acct.accountType === AccountType.BROKERED;
        form.change(
          "billToAccountId",
          isBrokered ? (acct.defaultBillToAccountId ?? null) : null,
        );
        const broker = await resolveBillToAccount(acct, allAccounts);
        if (!isCurrentSelection()) return;
        form.change("shipFrom", broker ? broker.businessName : null);

        // BROKERED: shipment bills to the broker, so skipInvoice follows the
        // broker; the operating account's own flag would hide billing forever.
        form.change("skipInvoice", getEffectiveSkipInvoice(acct, broker));

        setAccount(acct);
        const duplicateInbound = await validatePoNumberUnicity(
          { ...formData, accountId },
          notify,
        );
        if (!isCurrentSelection()) return;
        setDuplicatePoNumber(duplicateInbound);
      } catch (error) {
        logError(
          "inboundShipment:InboundCreate:handleAccountChangeAdvice",
          error,
          isCurrentSelection() ? notify : false,
        );
      } finally {
        if (isCurrentSelection()) setLoading(false);
      }
    }
  };

  const handleCarrierTypeChange = (event) => {
    const carrier = event?.target?.value;
    const formData = form.getState().values;

    if (carrier === CarrierType.RAIL) {
      setCarrierEquipmentChoices(railEquipmentChoices);
    } else if (carrier === CarrierType.TRUCK) {
      setCarrierEquipmentChoices(truckEquipmentChoices);

      if (formData.sit) {
        form.change("sit", false);
        notify("SIT has been disabled", "warning");
      }
    } else {
      setCarrierEquipmentChoices([]);
    }
    form.change("carrierEquipmentTypeId", "");

    // Only trucking companies are Carrier records, so a rail load has no id to
    // hold. Left behind, it would keep pointing at the trucking company while
    // the free-text field the rail branch renders renames the load out from
    // under it.
    if (carrier !== CarrierType.TRUCK) form.change("carrierId", null);
  };

  const handlePoNumberChange = (event, formData) => {
    const effectiveAccount = account;
    const value = event.target.value?.toUpperCase() || "";
    setDuplicatePoNumber(null);
    if (formData.lotNumberOverride !== true && formData.lotType) {
      const nextFormData = { ...formData, poNumber: value };
      form.change(
        "lotNumber",
        autogenLotNumber(formData.lotType, nextFormData, effectiveAccount),
      );
    }
  };

  const handlePoNumberBlur = async () => {
    const duplicateInbound = await validatePoNumberUnicity(
      form.getState().values,
      notify,
    );
    setDuplicatePoNumber(duplicateInbound);
  };

  const handleRailCarNumberChange = (event, formData) => {
    const value = event.target.value?.toUpperCase() || "";
    if (formData.lotNumberOverride !== true && formData.lotType) {
      const nextFormData = { ...formData, railCarNumber: value };
      form.change(
        "lotNumber",
        autogenLotNumber(formData.lotType, nextFormData, account),
      );
    }
  };

  const handleLotNoManualChange = (value, formData) => {
    if (value) form.change("lotNumber", lotNumber);
    else
      form.change(
        "lotNumber",
        autogenLotNumber(formData.lotType, formData, account),
      );
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getSealNumberButtonLabel = (formData) => {
    return `Manage Seals (${
      formData?.seals?.items?.length || formData?.sealNumbers?.length || 0
    })`;
  };

  const getAccountHelperText = () => {
    if (isInternalAccount(account)) return "Internal Account";
    if (isBrokeredAccount(account)) return "Brokered Account";
    return false;
  };

  const getPoNumberHelperText = () => {
    if (duplicatePoNumber) return "⚠️ Duplicate PO Number.";
    return false;
  };

  const handleStockImportChange = async (value, form) => {
    form.change("lotNumberOverride", true);
    // Stock imports skip billing outright, so only the way back to a normal
    // shipment needs the broker resolved.
    const accountId = account?.id ?? null;
    const broker = value
      ? null
      : await resolveBillToAccount(account, allAccounts);
    // That resolve can hit the network, so re-check the account for the same
    // reason handleAccountChange does: this toggle must not write a billing
    // default derived from an account the form has since left.
    if ((accountRequestRef.current ?? null) !== accountId) return;
    form.change(
      "skipInvoice",
      value || getEffectiveSkipInvoice(account, broker),
    );

    // form.change("inventories.items", []);
    // notify("Tally Sheet has been cleared", "warning");
  };

  if (entryPoint === "advices") {
    return (
      <AdviceCreateForm
        area={area}
        account={account}
        isBrokeredAccount={isBrokeredAccount}
        loading={loading}
        setAreas={setAreas}
        setYardCommodity={setYardCommodity}
        handleAccountChange={handleAccountChangeAdvice}
        handleCarrierTypeChange={handleCarrierTypeChange}
        handlePoNumberBlur={handlePoNumberBlur}
        getAccountHelperText={getAccountHelperText}
        onAccountsLoaded={setAllAccounts}
      />
    );
  }

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <Grid container spacing={4}>
          {setIsSit && (
            <SitStateSync sit={formData.sit} setIsSit={setIsSit} />
          )}
          <Grid item container direction="column" spacing={0} lg={8}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <AccountDropDown
                  source="accountId"
                  label="Account"
                  validate={validateRequired}
                  allowEmpty={false}
                  onAccountChange={(value) =>
                    handleAccountChange(value, formData)
                  }
                  onAccountsLoaded={setAllAccounts}
                  loading={loading}
                  helperText={getAccountHelperText()}
                />
              </Grid>
              {/* No defaultValue here: handleAccountChange already writes the
                  value, and react-admin's defaultValue effect re-applies it
                  whenever the field reads null — which undid the reset to a
                  non-brokered account while this picker was still mounted. */}
              {isBrokeredAccount(account) && (
                <Grid item xs={12} md={4}>
                  <AccountDropDown
                    source="billToAccountId"
                    label="Billing Account"
                    allowEmpty={false}
                    disabled={true}
                    loading={loading}
                    helperText={false}
                  />
                </Grid>
              )}
              <Grid item xs={12} md={4}>
                <TextInput
                  source="shipFrom"
                  label="Origin"
                  disabled={!account}
                  placeholder={account?.businessName}
                  InputLabelProps={{
                    shrink:
                      formData.shipFrom != null ||
                      account?.businessName != null,
                  }}
                  variant="outlined"
                  fullWidth
                  helperText={false}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextInput
                  source="poNumber"
                  label="PO Number"
                  parse={(v) => (v !== "" ? v.toUpperCase() : undefined)}
                  validate={validatePoNo}
                  onChange={(event) => handlePoNumberChange(event, formData)}
                  onBlur={handlePoNumberBlur}
                  inputProps={{ style: { textTransform: "uppercase" } }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CopyToClipboardButton
                          text={formData.poNumber || ""}
                          edge="end"
                          fontSize="small"
                          mb={0}
                        />
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  fullWidth
                  error={Boolean(duplicatePoNumber)}
                  helperText={getPoNumberHelperText()}
                  FormHelperTextProps={{
                    component: "div",
                    style: duplicatePoNumber ? { color: "#f44336" } : undefined,
                  }}
                />
              </Grid>
              {account?.trackInboundSeals && (
                <Grid item xs={12} md={4}>
                  <Box mt={1}>
                    <Button
                      label={getSealNumberButtonLabel(formData)}
                      onClick={handleOpen}
                      variant="outlined"
                      size="large"
                    >
                      <SealIcon />
                    </Button>
                  </Box>
                </Grid>
              )}
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <AutocompleteInput
                  source="reloadYardCommodityId"
                  label="Load Type"
                  choices={yardCommodities}
                  optionText={(choice) =>
                    `${choice.commodity.name} - ${choice.units}`
                  }
                  optionValue="id"
                  onChange={(value) =>
                    handleCommodityChange(
                      value,
                      form,
                      setYardCommodity,
                      area,
                      setAreas,
                    )
                  }
                  validate={validateRequired}
                  disabled={formData.inventories?.items?.length > 0}
                  variant="outlined"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <SelectInput
                  source="carrierType"
                  label="Carrier Type"
                  choices={CarrierTypes}
                  validate={validateRequired}
                  onChange={handleCarrierTypeChange}
                  disabled={formData.sit}
                  variant="outlined"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              {(railEquipmentChoices?.length > 0 ||
                truckEquipmentChoices?.length > 0) && (
                <Grid item xs={12} md={4}>
                  <SelectInput
                    source="carrierEquipmentTypeId"
                    label="Carrier Equipment Type"
                    choices={carrierEquipmentChoices}
                    allowEmpty
                    disabled={!carrierEquipmentChoices?.length}
                    variant="outlined"
                    fullWidth
                    helperText={false}
                  />
                  <SmartTipIcon label="carrier-equipment-type" mt={-1} />
                </Grid>
              )}
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                {/* Only trucking companies exist as Carrier records, so only a
                    truck load has a list to pick from. A rail carrier name is
                    the railroad's mark — free text with no record behind it —
                    and it stays a plain field. */}
                {formData.carrierType === CarrierType.TRUCK ? (
                  <CarrierNameInput source="carrierName" label="Carrier Name" />
                ) : (
                  <TextInput
                    source="carrierName"
                    label="Carrier Name"
                    variant="outlined"
                    fullWidth
                    helperText={false}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                <TextInput
                  source="railCarNumber"
                  label={
                    formData.carrierType === CarrierType.RAIL
                      ? "Railcar Number"
                      : "Trailer Number"
                  }
                  parse={(v) => (v !== "" ? v.toUpperCase() : undefined)}
                  validate={
                    formData.carrierType === CarrierType.RAIL
                      ? validateRequired
                      : undefined
                  }
                  onChange={(event) =>
                    handleRailCarNumberChange(event, formData)
                  }
                  onBlur={() => validateRailCarNumberUnicity(formData, notify)}
                  inputProps={{ style: { textTransform: "uppercase" } }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CopyToClipboardButton
                          text={formData.railCarNumber || ""}
                          edge="end"
                          fontSize="small"
                          mb={0}
                        />
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              {formData?.containerDrop && (
                <Grid item xs={12} md={4}>
                  <TextInput
                    source="containerNumber"
                    label="Container Number"
                    parse={(v) => (v !== "" ? v.toUpperCase() : undefined)}
                    validate={validateContainerNumber}
                    onChange={(event) =>
                      handleContainerNumberChange(event.target.value, form)
                    }
                    inputProps={{ style: { textTransform: "uppercase" } }}
                    variant="outlined"
                    fullWidth
                    helperText={false}
                  />
                </Grid>
              )}
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <SelectInput
                  source="areaId"
                  label="Default Area"
                  disabled={formData.sit || !account || !yardCommodity?.id}
                  choices={areas || []}
                  onChange={(event) =>
                    handleAreaChange(
                      event.target.value,
                      areas,
                      setArea,
                      form,
                      notify,
                    )
                  }
                  validate={validateRequired}
                  variant="outlined"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <SelectInput
                  source="zoneId"
                  label="Default Zone"
                  disabled={!account || !area}
                  choices={area?.zones?.items}
                  allowEmpty={!account?.requireDefaultZone}
                  validate={
                    account?.requireDefaultZone ? validateRequired : undefined
                  }
                  variant="outlined"
                  fullWidth
                  helperText={false}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <SelectInput
                  source="lotType"
                  label="Lot Type"
                  disabled={!account}
                  choices={LotTypes}
                  validate={validateRequired}
                  onChange={(event) =>
                    handleLotTypeChange(event.target.value, form, account)
                  }
                  variant="outlined"
                  fullWidth
                  helperText={false}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextInput
                  source="lotNumber"
                  label="Lot Number"
                  disabled={formData.lotNumberOverride !== true}
                  parse={(v) => (v !== "" ? v.toUpperCase() : undefined)}
                  validate={validateRequired}
                  onChange={(event) => setLotNumber(event.target.value)}
                  inputProps={{ style: { textTransform: "uppercase" } }}
                  variant="outlined"
                  fullWidth
                  helperText={false}
                />
              </Grid>
            </Grid>
            <CustomFields
              {...props}
              accountFields={account?.inboundCustomFields}
              width={6}
              disabled={false}
            />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <fieldset>
                  <legend>
                    <Typography variant="overline" color="textSecondary">
                      Options
                    </Typography>
                  </legend>
                  <Grid container direction="row" spacing={0}>
                    <Grid item xs={6} md={3}>
                      <RadioButtonGroupInput
                        source="lotNumberOverride"
                        label="Lot # Override"
                        row
                        choices={TrueOrFalse}
                        defaultValue={false}
                        disabled={!account || formData.stockImport}
                        onChange={(value) =>
                          handleLotNoManualChange(value, formData)
                        }
                        helperText={false}
                      />
                    </Grid>
                    {!formData.sit && (
                      <Grid item xs={6} md={3}>
                        <RadioButtonGroupInput
                          source="secondaryReview"
                          label="Secondary Review"
                          row
                          choices={TrueOrFalse}
                          defaultValue={false}
                          validate={validateRequired}
                          disabled={formData.sit || formData.containerDrop}
                          helperText={false}
                        />
                      </Grid>
                    )}
                    <Grid item xs={6} md={3}>
                      <RadioButtonGroupInput
                        source="skipInvoice"
                        label="Skip Billing"
                        row
                        choices={TrueOrFalse}
                        defaultValue={false}
                        validate={validateRequired}
                        helperText={false}
                      />
                    </Grid>
                    {!formData.sit && (
                      <Grid item xs={6} md={3}>
                        <RadioButtonGroupInput
                          source="stockImport"
                          label="Stock Import"
                          row
                          choices={TrueOrFalse}
                          defaultValue={false}
                          disabled={
                            formData.sit ||
                            formData.containerDrop ||
                            formData.inventories?.items?.length > 0
                          }
                          onChange={(value) =>
                            handleStockImportChange(value, form)
                          }
                          validate={validateRequired}
                          helperText={false}
                        />
                      </Grid>
                    )}
                    {!formData.sit && (
                      <Grid item xs={6} md={3}>
                        <RadioButtonGroupInput
                          source="containerDrop"
                          label="ISOtainer Drop"
                          row
                          choices={TrueOrFalse}
                          defaultValue={false}
                          validate={validateRequired}
                          disabled={!isContainerDropEnabled(formData, area)}
                          onChange={(value) =>
                            handleContainerDropChange(value, form)
                          }
                          helperText={false}
                        />
                        <BetaBadge />
                      </Grid>
                    )}
                    <Grid item xs={6} md={3}>
                      <RadioButtonGroupInput
                        source="sit"
                        label="SIT"
                        row
                        choices={TrueOrFalse}
                        defaultValue={false}
                        onChange={(value) =>
                          handleSITChange(value, form, account, setArea)
                        }
                        validate={validateRequired}
                        disabled={isSITDisabled(formData)}
                        helperText={false}
                      />
                      <BetaBadge />
                    </Grid>
                  </Grid>
                </fieldset>
              </Grid>
            </Grid>
          </Grid>
          <Grid item container direction="row" spacing={0} xs={false} md={4}>
            <Grid item xs={12}>
              <FileInput
                source="attachments"
                label="ATTACHMENTS"
                className={classes.fileInput}
                placeholder={
                  <p>
                    <AttachFileIcon fontSize="large" /> <br /> Drop files to
                    upload, or click to select.
                  </p>
                }
                accept={ACCEPTED_FILES}
                multiple
                maxFiles={MAX_FILES}
                options={{ maxFiles: MAX_FILES }}
                onChange={(value) =>
                  handleFileChange("attachments", value, form, notify)
                }
                variant="outlined"
                fullWidth
                helperText={false}
              >
                <FileField source="src" title="title" target="_blank" />
              </FileInput>
            </Grid>
            <Grid item xs={12}>
              <PhotoInput
                source="photos.items"
                label="PHOTOS"
                disabled={!account}
                maxFiles={MAX_PHOTO_NUM_INBOUND}
                thumbs={3}
                parentType={ResourceType.INBOUND}
                storeDir={`${FilePaths.INBOUND}/${Date.now()}`}
                photos={photos}
                setPhotos={setPhotos}
              />
            </Grid>
          </Grid>
          <SealNumbersCreateDialog
            open={open}
            onClose={handleClose}
            formData={formData}
          />
        </Grid>
      )}
    </FormDataConsumer>
  );
};

const RemoveCopyButtons = ({
  form,
  setWeightError,
  yardCommodity,
  ...props
}) => {
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  const handleCopy = () => {
    var n = props.className.lastIndexOf("-");
    var index = Number(props.className.substring(n + 1));
    const inventoryFieldState = form.getFieldState("inventories.items");
    const data = inventoryFieldState?.value[index];
    const totalUOM = form.getState().values.totalUOM;

    if (inventoryFieldState?.value) {
      debugger;
      const newRow = {
        status: InventoryStatus.NEW,
        productName: data.productName,
        productCode: data.productCode,
        productId: data.productId,
        product: data.product,
        quantityAdvised: data.quantityAdvised,
        quantityReceived: data.quantityReceived,
        inventoryUOM: data.inventoryUOM || totalUOM,
        // pcs: data.pcs, // commented out to keep product default
        reloadYardCommodityId: data.reloadYardCommodityId,
        weight: data.weight,
        weightUnits: data.weightUnits,
        weightUOM: data.weightUOM,
        customFields: data.customFields,
      };
      form.change("inventories.items", [...inventoryFieldState.value, newRow]);
      handleInventoriesQty(form);
      handleInventoriesWeight(form, setWeightError);
    }
  };

  const handleRemove = (event) => {
    props.onClick(event);
    handleInventoriesQty(form);
    handleInventoriesWeight(form, setWeightError);
  };

  return (
    <Grid
      container
      direction={isXSmall ? "row" : "column"}
      spacing={1}
      alignItems="flex-end"
    >
      <Grid item xs={2} sm={12}>
        <Button label="Remove" color="default" onClick={handleRemove}>
          <RemoveIcon />
        </Button>
      </Grid>
      {!isBulkCommodity(yardCommodity?.commodity) && (
        <Grid item xs={2} sm={12}>
          <Button
            label="Copy"
            color="default"
            size="small"
            onClick={handleCopy}
          >
            <CopyDownIcon />
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

const TallySheetTab = ({ backPath, account, yardCommodity, ...props }) => {
  const form = useForm();
  const classes = useStyles();
  const [weightError, setWeightError] = useState(null);
  const [selectedFields, setSelectedFields] = useState([]);
  const [chargeRules, setChargeRules] = useState([]);
  const [autoCharges, setAutoCharges] = useState([]);

  useEffect(() => {
    if (account) setSelectedFields(account.inventoryCustomFields);
    else setSelectedFields([]);
  }, [account]);

  useEffect(() => {
    // All inbound charge rules for the effective billing account; MANUAL +
    // applicability is filtered at render time. BROKERED shipments bill to the
    // broker (billToAccountId, seeded from the account's defaultBillToAccountId
    // on account select) and INTERNAL ones to a user-picked billing account, so
    // the rules must follow billToAccountId, not the shipment's own account.
    let currentBillingAccountId = null;
    let isMounted = true;

    const fetchInboundChargeRules = async (billingAccountId) => {
      if (!billingAccountId) {
        if (isMounted) setChargeRules([]);
        return;
      }
      try {
        const rules = await fetchInboundBillingRules(billingAccountId);
        // Out-of-order guard: a slow response for a previously selected billing
        // account must not overwrite the current account's rules.
        if (isMounted && billingAccountId === currentBillingAccountId) {
          setChargeRules(rules);
        }
      } catch (error) {
        logError(
          "inboundShipments:InboundCreate:TallySheetTab:manualChargeRules",
          error,
          false,
        );
        if (isMounted && billingAccountId === currentBillingAccountId) {
          setChargeRules([]);
        }
      }
    };

    const getFormBillingAccountId = (values = {}) =>
      values?.billToAccountId || account?.id;

    currentBillingAccountId = getFormBillingAccountId(form.getState().values);
    fetchInboundChargeRules(currentBillingAccountId);

    const unsubscribe = form.subscribe(
      ({ values }) => {
        const nextBillingAccountId = getFormBillingAccountId(values);
        if (nextBillingAccountId !== currentBillingAccountId) {
          currentBillingAccountId = nextBillingAccountId;
          fetchInboundChargeRules(nextBillingAccountId);
        }
      },
      { values: true },
    );

    return () => {
      isMounted = false;
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account?.id]);

  useEffect(() => {
    // Subscribe to form changes to calculate auto charges, est. net weight and total quantity
    const unsubscribe = form.subscribe(
      ({ values }) => {
        const formData = values;
        setAutoCharges(getAutoCharges(formData, chargeRules));
        const weightUOM =
          formData?.weightUnits ||
          formData?.scaleWeightUnits ||
          getWeightUOM(account, null);
        const net = calcNetWeight(formData, setWeightError, weightUOM);
        const nextNetWeight = net != null ? net : null;
        if (formData?.netWeight !== nextNetWeight) {
          form.change("netWeight", nextNetWeight);
        }
        if (weightUOM && formData?.weightUnits !== weightUOM) {
          form.change("weightUnits", weightUOM);
        }
      },
      { values: true },
    );

    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, chargeRules]);

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => {
        const billingAccount = account;
        return (
          <Grid container spacing={0}>
            <Grid item xs={12} className={classes.arrayInputHeader}>
              <Typography variant="overline" color="textSecondary">
                INBOUND INVENTORY:
              </Typography>
              <CustomFieldsButton
                form={form}
                accountFields={billingAccount?.inventoryCustomFields}
                selectedCustomFields={selectedFields}
                setSelectedFields={setSelectedFields}
              />
            </Grid>
            <Grid item xs={12}>
              <ArrayInput
                source="inventories.items"
                label={false}
                className={classes.arrayInput}
              >
                <SimpleFormIterator
                  addButton={
                    <AddCatalogUploadButtons
                      backPath={backPath}
                      form={form}
                      formData={formData}
                      account={account}
                      yardCommodity={yardCommodity}
                    />
                  }
                  removeButton={
                    <RemoveCopyButtons
                      form={form}
                      setWeightError={setWeightError}
                      yardCommodity={yardCommodity}
                    />
                  }
                >
                  <FormDataConsumer>
                    {({
                      scopedFormData, // The data for this item of the ArrayInput
                      getSource, // Function to get the valid source inside an ArrayInput. Translates to "inventories.items[].property"
                      ...rest
                    }) =>
                      scopedFormData && (
                        <Grid container direction="row" spacing={1}>
                          <Grid item xs={12} md={5}>
                            <TextInput
                              source={getSource("productName")}
                              label="Product Name"
                              variant="outlined"
                              fullWidth
                              validate={validateRequired}
                              helperText={false}
                              InputProps={{
                                endAdornment: getInfoBubble(
                                  formData,
                                  scopedFormData,
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <NumberInput
                              source={getSource("quantityAdvised")}
                              label="Qty Advised"
                              variant="outlined"
                              fullWidth
                              min="0"
                              validate={validateQuantity}
                              onChange={() => handleInventoriesQty(form)}
                              helperText={false}
                              InputProps={{ endAdornment: formData.totalUOM }}
                            />
                          </Grid>
                          {isInventoryFieldVisible(
                            InventoryField.PCS,
                            scopedFormData?.reloadYardCommodityId,
                          ) && (
                            <Grid item xs={12} md={3}>
                              <NumberInput
                                source={getSource("pcs")}
                                label="Pieces / Unit"
                                variant="outlined"
                                fullWidth
                                min="1"
                                placeholder={scopedFormData?.product?.pcs}
                                InputLabelProps={{
                                  shrink:
                                    scopedFormData?.pcs != null ||
                                    scopedFormData?.product?.pcs != null,
                                }}
                                validate={validatePieces}
                                helperText={false}
                              />
                            </Grid>
                          )}
                          {showWeight(account, scopedFormData) && (
                            <Grid item xs={12} md={3}>
                              <NumberInput
                                source={getSource("weight")}
                                label="Weight"
                                variant="outlined"
                                fullWidth
                                min="0"
                                validate={validateQuantity}
                                onChange={() =>
                                  handleInventoriesWeight(form, setWeightError)
                                }
                                helperText={false}
                                InputProps={{
                                  endAdornment: `${getWeightUOM(
                                    account,
                                    scopedFormData,
                                  )}/${formData.totalUOM}`,
                                }}
                              />
                            </Grid>
                          )}
                          <CustomFieldsTallySheet
                            {...props}
                            getSource={getSource}
                            recordFields={scopedFormData?.customFields}
                            accountFields={selectedFields}
                            header={false}
                            width={3}
                            disabled={false}
                          />
                        </Grid>
                      )
                    }
                  </FormDataConsumer>
                </SimpleFormIterator>
              </ArrayInput>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                Total Load
              </Typography>
              <Grid container direction="row" spacing={1}>
                <Grid item xs={6} md={3}>
                  <MuiTextField
                    label="Total Quantity"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    disabled
                    value={calcTotalQuantity(formData) ?? ""}
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <SelectInput
                    source="totalUOM"
                    label="Inventory UOM"
                    variant="outlined"
                    fullWidth
                    choices={getCommodityUnits(yardCommodity)}
                    optionText={unitOptionRenderer}
                    initialValue="UNIT"
                    validate={validateRequired}
                    onChange={() => handleUnitChange(form)}
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <NumberInput
                    source="netWeight"
                    label="Est. Net Weight"
                    variant="outlined"
                    fullWidth
                    disabled
                    helperText={weightError ? weightError : false}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      endAdornment:
                        formData?.scaleWeightUnits ||
                        formData?.weightUnits ||
                        "",
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {!formData?.skipInvoice && isAuthorized(AclType.INVOICES) && (
              <Grid item xs={12}>
                <fieldset>
                  <legend>
                    <Typography variant="overline" color="textSecondary">
                      Billing <NewBadge />
                    </Typography>
                  </legend>
                  <Grid container spacing={8}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="overline" color="textSecondary">
                        Auto Charges
                      </Typography>
                      <ArrayField
                        record={autoCharges}
                        source="items"
                        label={false}
                        fullWidth
                      >
                        <Datagrid>
                          <FunctionField
                            label="Service"
                            render={(record) => {
                              // Extract service name from serviceNote
                              const parts =
                                record?.serviceNote?.split(" - ") || [];
                              return parts[0] || "";
                            }}
                          />
                          <FunctionField
                            label="Quantity"
                            render={(record) => {
                              const qty = Number(record?.quantity || 0);
                              const units = record?.units || "";
                              return qty ? `${qty} ${getUnitName(units)}` : "";
                            }}
                          />
                          <FunctionField
                            label="Est. Charge"
                            render={(record) => {
                              const amount = Number(record?.amount || 0);
                              return amount ? `$${amount.toFixed(2)}` : "";
                            }}
                          />
                        </Datagrid>
                      </ArrayField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="overline" color="textSecondary">
                        Manual Charges
                      </Typography>
                      <SmartTipIcon
                        label="manual-charges"
                        alignRight={false}
                        mt={20}
                      />
                      <ArrayInput
                        source="manualCharges.items"
                        label={false}
                        fullWidth
                        disabled={!chargeRules?.length}
                      >
                        <SimpleFormIterator disableReordering={true}>
                          <FormDataConsumer>
                            {({ getSource, scopedFormData }) => {
                              const applicableRules =
                                filterApplicableManualRules(
                                  formData,
                                  chargeRules,
                                  ChargeEvent.INBOUND,
                                );
                              const selectedRule = applicableRules.find(
                                (rule) =>
                                  rule.id === scopedFormData?.chargeRuleId,
                              );
                              const billingUOM = getUnitName(
                                selectedRule?.billingUOM,
                              );
                              return (
                                <Grid container direction="row" spacing={1}>
                                  <Grid item xs={7}>
                                    <SelectInput
                                      source={getSource("chargeRuleId")}
                                      label="Service"
                                      variant="outlined"
                                      fullWidth
                                      helperText={false}
                                      choices={getManualRuleChoices(
                                        applicableRules,
                                        scopedFormData,
                                      )}
                                      onChange={(value) =>
                                        applyManualRuleDefaultQuantity({
                                          value,
                                          applicableRules,
                                          formData,
                                          scopedFormData,
                                          form,
                                          getSource,
                                        })
                                      }
                                    />
                                  </Grid>
                                  <Grid item xs={5}>
                                    <NumberInput
                                      source={getSource("quantity")}
                                      label="Quantity"
                                      variant="outlined"
                                      fullWidth
                                      min="0"
                                      validate={validateQuantity}
                                      helperText={getManualChargeAmount(
                                        selectedRule,
                                        scopedFormData,
                                      )}
                                      InputProps={{
                                        endAdornment: billingUOM,
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              );
                            }}
                          </FormDataConsumer>
                        </SimpleFormIterator>
                      </ArrayInput>
                    </Grid>
                  </Grid>
                </fieldset>
              </Grid>
            )}
          </Grid>
        );
      }}
    </FormDataConsumer>
  );
};

const DispatchTab = ({ account, selectedTimeslot, setSelectedTimeslot }) => {
  const form = useForm();
  const notify = useNotify();
  const [isSchedulerOpen, setIsSchedulerOpen] = useState(false);
  const [eventType, setEventType] = useState(null);

  form.registerField("scheduledDateTime", () => {}, {
    active: true,
    dirty: true,
    touched: true,
    valid: true,
    value: true,
  });

  const handleTimeslot = (timeslot) => {
    if (timeslot) {
      const scheduledDate = resolveScheduledDateTime(timeslot, {
        notify,
        scope: "inboundShipments:InboundCreate:DispatchTab:handleTimeslot",
      });
      if (!scheduledDate) return;
      form.change("scheduledDateTime", scheduledDate);
      setSelectedTimeslot(timeslot);
      if (timeslot.eventType) setEventType(timeslot.eventType);
    } else {
      form.change("scheduledDateTime", null);
      setSelectedTimeslot(null);
    }
  };

  // A picked (unsaved) appointment carries the pick-time account's auth
  // groups; saving it under a different account would leave the Timeslot
  // row authorized to the old account's customers. Reset it like the other
  // account-linked fields.
  useEffect(() => {
    if (
      selectedTimeslot &&
      account?.id &&
      selectedTimeslot.accountId &&
      selectedTimeslot.accountId !== account.id
    ) {
      handleTimeslot(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account?.id, selectedTimeslot]);

  const handleSchedulerOpen = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (account) setIsSchedulerOpen(true);
  };

  const getSchedulerHelperText = () => {
    const events = window.appUser.reloadYard.eventTypes?.items?.length;
    if (!events) return `Setup Schedule and Event Type to enable.`;
    if (!account) return "Choose an account before scheduling.";
    return false;
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <FormDataConsumer>
        {({ formData }) => (
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12} md={3}>
              <DateTimePicker
                label="Time Scheduled"
                margin="dense"
                inputVariant="outlined"
                variant="dialog"
                fullWidth
                disabled={!account}
                onClickCapture={handleSchedulerOpen}
                value={
                  !formData.scheduledDateTime
                    ? null
                    : getDateTimeFromUtc(formData.scheduledDateTime)
                }
                format="MM/dd/yyyy hh:mm a"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <CreatedAtIcon />
                    </InputAdornment>
                  ),
                }}
                onChange={() => {}}
                helperText={getSchedulerHelperText()}
              />
              {account && (
                <Scheduler
                  account={account}
                  eventType={eventType}
                  setEventType={setEventType}
                  selectedTimeslot={selectedTimeslot}
                  setSelectedTimeslot={handleTimeslot}
                  open={isSchedulerOpen}
                  setIsOpen={setIsSchedulerOpen}
                  resettable={true}
                  workflow={Workflow.INBOUND}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              <EventsCalendar
                eventType={eventType}
                selectedTimeslot={selectedTimeslot}
                account={account}
                onTimeslotPick={account ? handleTimeslot : undefined}
                disableClick
              />
            </Grid>
          </Grid>
        )}
      </FormDataConsumer>
    </MuiPickersUtilsProvider>
  );
};

const InboundCreateActions = ({ basePath, data, resource, ...props }) => (
  <TopToolbar>
    <HelpButton>
      <InboundCreateHelp {...props} />
    </HelpButton>
    <BackButton basePath={basePath} />
  </TopToolbar>
);

// Validate form and return error to prevent form submission
const validateInboundCreate = (values) => {
  let errors = {};
  // validate carrier name and number
  if (values.carrierType === CarrierType.RAIL) {
    if (!values.railCarNumber) errors.railCarNumber = "Required";
  }

  return errors;
};

export const InboundCreate = (props) => {
  const [account, setAccount] = useState();
  const [yardCommodity, setYardCommodity] = useState();
  const [photos, setPhotos] = useState([]);
  const [entryPoint, setEntryPoint] = useState();
  const [selectedTimeslot, setSelectedTimeslot] = useState();
  const backPath = getBackPath(props);
  // Default the SIT option from navigation state (e.g. created from the SIT
  // list); a restored savedRecord still wins if it carries its own sit value.
  const initValues = {
    sit: props.location?.state?.sit ?? false,
    ...(props.location?.state?.savedRecord || {}),
  };
  // SIT railcars skip the checklist workflow, so the Checklist tab is hidden.
  // This tracks the LIVE form value (kept in sync by SitStateSync) rather than
  // only the navigation-state flag, so toggling the SIT radio on/off on the
  // Inbound Setup tab shows/hides the tab accordingly.
  const [isSit, setIsSit] = useState(Boolean(initValues.sit));

  useEffect(() => {
    if (initValues.account && initValues.reloadYardCommodity) {
      setAccount(initValues.account);
      setYardCommodity(initValues.reloadYardCommodity);
    }
    if (props.location?.state?.entryPoint) {
      setEntryPoint(props.location?.state?.entryPoint);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location?.state?.savedRecord, props.location?.state?.entryPoint]);

  return (
    <Create
      {...props}
      title={<ForceTitle title="New Inbound" />}
      actions={<InboundCreateActions {...props} />}
    >
      {entryPoint === "advices" ? (
        <TabbedForm
          variant="outlined"
          initialValues={initValues}
          submitOnEnter={false}
          toolbar={
            <InboundCreateAdviceToolbar account={account} photos={photos} />
          }
          // validate={(values) => validateInboundCreate(values)}
        >
          <FormTab
            path=""
            label={
              <span>
                Inbound Setup
                <BetaBadge />
              </span>
            }
          >
            <ShipmentSetupTab
              {...props}
              account={account}
              setAccount={setAccount}
              yardCommodity={yardCommodity}
              setYardCommodity={setYardCommodity}
              entryPoint={entryPoint}
              photos={photos}
              setPhotos={setPhotos}
            />
          </FormTab>
        </TabbedForm>
      ) : (
        <TabbedForm
          variant="outlined"
          initialValues={initValues}
          submitOnEnter={false}
          toolbar={
            <InboundCreateToolbar
              account={account}
              operatingAccount={account}
              photos={photos}
              entryPoint={entryPoint}
              selectedTimeslot={selectedTimeslot}
            />
          }
          validate={(values) => validateInboundCreate(values)}
        >
          <FormTab path="" label="Inbound Setup">
            <ShipmentSetupTab
              {...props}
              account={account}
              setAccount={setAccount}
              yardCommodity={yardCommodity}
              setYardCommodity={setYardCommodity}
              entryPoint={entryPoint}
              photos={photos}
              setPhotos={setPhotos}
              setIsSit={setIsSit}
            />
          </FormTab>
          <FormTab path="tallySheet" label="Tally Sheet">
            <TallySheetTab
              {...props}
              backPath={backPath}
              account={account}
              yardCommodity={yardCommodity}
            />
          </FormTab>
          {!isSit && (
            <FormTab
              path="checklist"
              label={
                <span>
                  Checklist
                  <BetaBadge />
                </span>
              }
            >
              <ChecklistTab
                {...props}
                account={account}
                yardCommodity={yardCommodity}
              />
            </FormTab>
          )}
          <FormTab path="dispatch" label="Dispatch">
            <DispatchTab
              {...props}
              account={account}
              selectedTimeslot={selectedTimeslot}
              setSelectedTimeslot={setSelectedTimeslot}
            />
          </FormTab>
          <FormTab path="notes" label="Notes">
            <NotesTab />
          </FormTab>
        </TabbedForm>
      )}
    </Create>
  );
};

const InboundCreateToolbar = ({
  account,
  operatingAccount,
  photos,
  entryPoint,
  selectedTimeslot,
  ...props
}) => {
  return (
    <Toolbar {...props}>
      <ValidateCreateButton
        account={account}
        operatingAccount={operatingAccount}
        photos={photos}
        entryPoint={entryPoint}
        selectedTimeslot={selectedTimeslot}
      />
    </Toolbar>
  );
};

const InboundCreateAdviceToolbar = ({
  account,
  photos,
  entryPoint,
  ...props
}) => {
  return (
    <Toolbar {...props}>
      <ValidateCreateAdviceButton account={account} entryPoint={entryPoint} />
    </Toolbar>
  );
};

const ChecklistTab = ({ account, yardCommodity, ...props }) => {
  const form = useForm();
  const classes = useStyles();

  useEffect(() => {
    if (account?.checklists?.items && yardCommodity) {
      debugger;
      const values = form.getState().values;
      account.checklists.items = account.checklists.items?.filter(
        (itm) =>
          itm.processName === "Inbound Shipment" &&
          itm.active &&
          (itm.reloadYardCommodityId === values.reloadYardCommodityId ||
            !itm.reloadYardCommodityId),
      );
      const checklist = account.checklists?.items?.find(
        (itm) => itm.reloadYardCommodityId === values.reloadYardCommodityId,
      );
      if (checklist) {
        form.change("checklistId", checklist.id);
        form.change("checklist", checklist.checklistItems);
      } else {
        form.change("checklistId", null);
        form.change("checklist", null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, yardCommodity]);

  const handleChecklistChange = async (event) => {
    if (event.target.value) {
      debugger;
      const checklist = account.checklists.items.find(
        (itm) => itm.id === event.target.value,
      );
      form.change("checklist", checklist.checklistItems);
    } else {
      form.change("checklist", null);
    }
  };

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <Grid container direction="row" spacing={3}>
          <Grid item xs={12}>
            <TextInput
              source="instructions"
              label="Special Instructions"
              variant="outlined"
              multiline
              fullWidth
              disabled={!account}
              helperText={false}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <SelectInput
              source="checklistId"
              label="Checklist"
              variant="outlined"
              fullWidth
              choices={account?.checklists?.items || []}
              optionText={(choice) => `${choice.name}`}
              optionValue="id"
              helperText={false}
              allowEmpty
              disabled={!account}
              onChange={handleChecklistChange}
            />
          </Grid>
          {
            <Grid item xs={12}>
              <Checklist
                {...props}
                workFlowSteps={InboundStepsChoices}
                source="checklist"
                label="Checklist Items"
                className={classes.arrayInput}
              />
            </Grid>
          }
        </Grid>
      )}
    </FormDataConsumer>
  );
};
